export enum MathOperator {
  /**
   * 区间
   */
  RANGE = 0,

  /**
   * 大于 >
   */
  GT = 1,

  /**
   * 大于等于 >=
   */
  GTE = 2,

  /**
   * 等于 =
   */
  EQ = 3,

  /**
   * 小于 <
   */
  LT = 4,

  /**
   * 小于等于 <=
   */
  LTE = 5,

  /**
   * 约等于 ≈
   */
  AE = 6
}

export const MathOperatorTextMap = {
  [MathOperator.RANGE]: '区间',
  [MathOperator.GT]: '＞',
  [MathOperator.GTE]: '≥',
  [MathOperator.EQ]: '＝',
  [MathOperator.LT]: '＜',
  [MathOperator.LTE]: '≤',
  [MathOperator.AE]: '≈'
}
